document.addEventListener('DOMContentLoaded', function () {
  if ($(window).width() <= 590 && $(`.guideimagelist`).length) {
    $(` .guideimagelist`).slick({
      infinite: false,
      draggable: true,
      slidesToShow: 2.1,
      slidesToScroll: 1,
      dots: true,
      arrow: false,
    });
  }
});